import { create } from "zustand";
import {
	clearStoredTokens,
	getStoredAccessToken,
	setStoredTokens,
} from "@/shared/utils/token";
import type { User } from "../types";

interface AuthState {
	user: User | null;
	accessToken: string | null;
	isAuthenticated: boolean;
	isLoading: boolean;
}

interface AuthActions {
	setAuth: (user: User, accessToken: string) => void;
	setUser: (user: User) => void;
	setLoading: (loading: boolean) => void;
	logout: () => void;
	hydrate: () => void;
}

type AuthStore = AuthState & AuthActions;

export const useAuthStore = create<AuthStore>((set) => ({
	user: null,
	accessToken: null,
	isAuthenticated: false,
	isLoading: true,

	setAuth: (user, accessToken) => {
		setStoredTokens(accessToken);
		set({
			user,
			accessToken,
			isAuthenticated: true,
			isLoading: false,
		});
	},

	setUser: (user) => {
		set({ user, isAuthenticated: true, isLoading: false });
	},

	setLoading: (loading) => {
		set({ isLoading: loading });
	},

	logout: () => {
		clearStoredTokens();
		set({
			user: null,
			accessToken: null,
			isAuthenticated: false,
			isLoading: false,
		});
	},

	hydrate: () => {
		const accessToken = getStoredAccessToken();
		if (accessToken) {
			set({ accessToken, isLoading: true });
		} else {
			set({ isLoading: false });
		}
	},
}));
